import { useGenericQuery } from "../../hooks/useQueries";
import SuperDropdown from "../dropdown/SuperDropdown";
import DefaultDropdownItem from "../dropdown/DefaultDropdownItem";
import Spinner from "../spinner/Spinner";
import DefaultLoadingError from "../error/DefaultLoadingError";
import { UseComboboxStateChange } from "downshift";

export default function AutoCompleteUdvalg(props: {
  onSelectedItemChange: (event: UseComboboxStateChange<IUdvalg>) => void;
  clearAfterSelection?: boolean;
  placeholder?: string;
}) {
  const { onSelectedItemChange, clearAfterSelection, placeholder } = props;

  const { data, isPending, error } = useGenericQuery<IUdvalg>("udvalg", {
    orderBy: "navn",
  });

  if (isPending) {
    return (
      <Spinner
        inline
        label="Henter data"
        className="form-control justify-content-start"
        size={14}
      />
    );
  }

  return (
    <>
      {(!data || error) && <DefaultLoadingError label={String(error)} />}

      <SuperDropdown
        clearInputAfterSelection={clearAfterSelection}
        disabled={!data || Boolean(error)}
        filterKeys={["navn"]}
        items={data}
        itemsIdKey="id"
        itemToString={(item) => item?.navn ?? ""}
        itemToElement={(item) => <DefaultDropdownItem label={item.navn} />}
        placeholder={placeholder}
        onSelectedItemEvent={(event) => onSelectedItemChange(event)}
      />
    </>
  );
}
